import {memo} from 'react'
import {RenderComponent} from 'src/biz/common/renderComponent'
import type {baseComponentType} from 'src/biz/types'
import {formatFormJsonValue} from 'src/biz/utils'
import {ConfigProvider, Form, Modal as UIModal} from 'src/ui'
import type {ModalProps} from 'src/ui'
import locale from 'src/ui/locale'
locale.DatePicker.lang = {
  ...locale.DatePicker.lang,
  shortMonths: ['1月', '2月', '3月', '4月', '5月', '6月', '7月', '8月', '9月', '10月', '11月', '12月'],
  shortWeekDays: ['日', '一', '二', '三', '四', '五', '六'],
}
export type ModalFormPropsType = ModalProps & {
  data: baseComponentType[]
  handleOk?: (form?: any) => void // 确认关闭回调
  handleCancel?: (form?: any) => void // 取消关闭回调
  open: boolean // 弹窗打开关闭控制
  modalTitle?: string // 弹窗title
  okText?: string // 确认按钮文字
  cancelText?: string // 	取消按钮文字
}

const ModalForm: React.FC<ModalFormPropsType> = props => {
  const [form] = Form.useForm()
  const {
    data,
    open,
    handleOk,
    handleCancel,
    modalTitle = '新增',
    getContainer,
    footer,
    classNames,
    style,
    ...rest
  } = props
  const ok = () => {
    const formValue = formatFormValue()
    props.handleOk?.(formValue)
  }
  const cancel = () => {
    const formValue = formatFormValue()
    props.handleCancel?.(formValue)
  }
  const formatFormValue = () => {
    const value = form.getFieldsValue()
    const data = formatFormJsonValue(props.data, value)
    return data
  }

  return (
    <ConfigProvider locale={locale}>
      <UIModal
        getContainer={getContainer || document.body}
        title={modalTitle}
        open={open}
        onOk={ok}
        onCancel={cancel}
        classNames={classNames}
        style={style}
        {...rest}
      >
        <Form form={form} layout={'horizontal'}>
          {data.map((comp: baseComponentType, index: number) => {
            const dataProps = {
              ...comp,
            }
            const propsWidth = dataProps.width ? `${dataProps.width}px` : ''
            const propsHeight = dataProps.height ? `${dataProps.height}px` : ''
            dataProps.style = {width: propsWidth, height: propsHeight}
            return (
              <Form.Item
                name={comp.name as string}
                label={comp.label}
                key={index as any}
                initialValue={comp.initialValue}
                rules={comp.rules}
              >
                <RenderComponent {...dataProps} />
              </Form.Item>
            )
          })}
        </Form>
      </UIModal>
    </ConfigProvider>
  )
}
export default memo(ModalForm)
